var map = {
	"./activities.raw.svg": 45385,
	"./animals_nature.raw.svg": 30377,
	"./flags.raw.svg": 63467,
	"./food_drink.raw.svg": 1948,
	"./nouns.raw.svg": 67551,
	"./objects.raw.svg": 89757,
	"./smileys_people.raw.svg": 38011,
	"./symbols.raw.svg": 61677,
	"./travel_places.raw.svg": 85066
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46497;